export default __webpack_public_path__ + "static/media/fired-user-logo.1fb219f2.svg";